import { render } from "./BakaShow.vue?vue&type=template&id=12ca5e9e"
import script from "./BakaShow.vue?vue&type=script&lang=js"
export * from "./BakaShow.vue?vue&type=script&lang=js"

import "./BakaShow.vue?vue&type=style&index=0&id=12ca5e9e&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__